import defaultAttributes from '../defaultAttributes';
import type { IconNode } from '../types';

const UserX2: IconNode = [
  'svg',
  defaultAttributes,
  [
    ['path', { d: 'M14 19a6 6 0 0 0-12 0' }],
    ['circle', { cx: '8', cy: '9', r: '4' }],
    ['line', { x1: '17', x2: '22', y1: '8', y2: '13' }],
    ['line', { x1: '22', x2: '17', y1: '8', y2: '13' }],
  ],
];

export default UserX2;
